angular.module('unergie.main')
.controller('temporaryConnectionModalCtrl', ($scope, $timeout, $uibModalInstance, DataAccess, DataAccessVariables, ReferencesService, ApiAdmin, ApiUser, CommonRegex, AlertManager, ModalService, BoFeaturesService,
    ErrorCatcher, ContractConstants, OrganizationService, PrmUtilsService, id_account) => {
    const ref = ContractConstants.ref
    $scope.phoneRegex = CommonRegex.phone.french
    const mobileRegex = CommonRegex.phone.mobiles
    $scope.nameRegex = CommonRegex.fullname

    $scope.isPrmValid = PrmUtilsService.isPrmValid

    $scope.tempConnectionRequest = {
        temp_class_powers: {},
    }

    $scope.checks = {
        notMobile: false,
    }

    $scope.selectedAccount = ''

    $scope.id_account = id_account || ''

    ReferencesService.getRef('inseepostcode', true).then((mapping) => {
        $scope.postcodes = _.uniq(_.map(mapping, 'postcode'))
    })

    OrganizationService.getServiceOrderOrgz().then((serviceOrderOrgz) => {
        $scope.serviceOrderOrgz = serviceOrderOrgz
    })

    $scope.selectAccount = (account) => {
        $scope.selectedAccount = account
        $scope.id_account = account.value
        $scope.refreshCategories()
    }

    $scope.emptyAccount = () => {
        $scope.selectedAccount = ''
        $scope.id_account = ''
        $scope.tempConnectionRequest.id_category = null
        $scope.categories = []
    }

    $scope.fetchingAffectables = true
    DataAccess.myAffectations().$promise.then((affectations) => {
        $scope.affectableAccount = _.map(affectations, (a) => {
            return { value: a.id_account, label: `${a.name}${BoFeaturesService.isFeatureOn('crossOrg') ? ` (${a.organization})` : ''}`, organization: a.organization, name: a.name }
        })

        if ($scope.id_account) {
            $scope.selectAccount(_.find($scope.affectableAccount, { value: $scope.id_account }))
        } else if ($scope.affectableAccount.length === 1) {
            $scope.selectAccount($scope.affectableAccount[0])
        }
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $timeout(() => {
            $scope.fetchingAffectables = false
        })
    })

    const powersSSCPT = []
    for (let pow = 0.1; pow <= 36; pow = Number((pow + 0.1).toFixed(1))) {
        powersSSCPT.push({ label: `${pow}kVA`, value: pow })
    }

    $scope.postcodeValid = () => {
        return $scope.postcodes && $scope.postcodes.includes($scope.tempConnectionRequest.addr_post_code)
    }

    $scope.motives = [
        'Chantier (construction neuve, rénovation)',
        'Forain (attraction, manège)',
        'Marché',
        'Manifestation culturelle ou sportive',
        'Grue de chantier',
        'Illuminations',
        'Installation mobile (caravane…)',
        'Autres (à préciser)',
    ]

    const routingTariffs = [
        { id: 'BTINFCUST', label: 'Courte utilisation sans différenciation temporelle (CUST)', for: ['BTINF'] },
        { id: 'BTINFMUDT', label: 'Moyenne utilisation avec différenciation temporelle (MUDT)', for: ['BTINF'] },
        { id: 'BTINFLU', label: 'Longue utilisation (LU)', for: ['BTINF'] },
        { id: 'BTSUPCU4', label: 'Courte utilisation (CU4)', for: ['BTSUP'] },
        { id: 'BTSUPLU4', label: 'Longue utilisation (LU4)', for: ['BTSUP'] },
        { id: 'HTACU5', label: 'Courte utilisation (CU5)', for: ['HTA'] },
        { id: 'HTALU5', label: 'Longue utilisation (LU5)', for: ['HTA'] },
    ]

    $scope.getRoutingTariffs = () => {
        return _.filter(routingTariffs, (r) => r.for.includes($scope.tempConnectionRequest.voltage_domain))
    }

    $scope.contexts = [
        { id: 'UPIN', label: 'Usage plat ou intensif de nuit' },
        { id: 'ECPU', label: 'Éclairage public' },
        { id: 'AUSA', label: 'Autre usage' },
    ]

    const voltageDomains = [
        { id: 'BTINF', label: 'BTINF - Inférieur ou égal à 36kVA' },
        { id: 'BTSUP', label: 'BTSUP - De 37 à 250kVA' },
        { id: 'HTA', label: 'HTA - Haute tension' },
    ]

    $scope.applicableVoltageDomains = []
    $scope.refreshVoltageDomains = () => {
        if ($scope.refreshingVoltageDomain) {
            return
        }
        $scope.refreshingVoltageDomain = true
        if ($scope.tempConnectionRequest.id_category) {
            return DataAccess.getAgreementForCategory({ id: $scope.tempConnectionRequest.id_category }).$promise.then((agreement) => {
                $scope.applicableVoltageDomains = _.filter(voltageDomains, (d) => {
                    switch (d.id) {
                        case ('HTA'):
                            return $scope.tempConnectionRequest.case_code !== 'F820' && agreement.allowed_segments.match(/(C2|C3)/)
                        case ('BTSUP'):
                            return agreement.allowed_segments.match(/(C4)/)
                        case ('BTINF'):
                            return agreement.allowed_segments.match(/(C5)/)
                        default:
                    }
                })
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.refreshingVoltageDomain = false
            })
        }
        $scope.applicableVoltageDomains = voltageDomains
        $scope.refreshingVoltageDomain = false
    }

    $scope.phasings = [
        { id: 'MONOPHASE', label: 'Monophasé' },
        { id: 'TRIPHASE', label: 'Triphasé' },
    ]

    $scope.isMotivationOther = (motivation) => {
        return motivation === _.last($scope.motives)
    }

    $scope.isLU = () => {
        return $scope.tempConnectionRequest.routing_tariff && $scope.tempConnectionRequest.routing_tariff === 'BTINFLU'
    }

    $scope.isMotivationOk = () => {
        return $scope.tempConnectionRequest.motivation && (!$scope.isMotivationOther($scope.tempConnectionRequest.motivation) || $scope.tempConnectionRequest.otherMotivation)
    }

    $scope.changePower = () => {
        if ($scope.tempConnectionRequest.max_power) {
            if ($scope.tempConnectionRequest.max_power < 9) {
                $scope.phasings = [
                    { id: 'MONOPHASE', label: 'Monophasé' },
                ]
            } else if ($scope.tempConnectionRequest.max_power > 12) {
                $scope.phasings = [
                    { id: 'TRIPHASE', label: 'Triphasé' },
                ]
            } else {
                $scope.phasings = [
                    { id: 'MONOPHASE', label: 'Monophasé' },
                    { id: 'TRIPHASE', label: 'Triphasé' },
                ]
            }
        }
        $scope.tempConnectionRequest.phasing = $scope.phasings[0].id
    }

    $scope.changeCalendar = () => {
        if ($scope.isLU()) {
            $scope.availablePower = powersSSCPT
        } else {
            $scope.availablePower = ref[`powers${$scope.tempConnectionRequest.id_p_calendar}`]
        }
        if ($scope.tempConnectionRequest.max_power && !_.map($scope.availablePower, 'value').includes($scope.tempConnectionRequest.max_power)) {
            $scope.tempConnectionRequest.max_power = $scope.availablePower[0].value
        }
        $scope.changePower()
    }

    $scope.changedRoutingTariff = () => {
        if ($scope.tempConnectionRequest.voltage_domain === 'BTINF') {
            $scope.calendars = [
                { id: 'BASE', label: 'Base' },
            ]
            if ($scope.isLU()) {
                $scope.calendars.push({ id: 'LU', label: 'Sans comptage' })
            } else {
                $scope.calendars.push({ id: 'HPHC', label: 'Heures pleines / heures creuses' })
            }
            if ($scope.tempConnectionRequest.id_p_calendar) {
                switch ($scope.tempConnectionRequest.routing_tariff) {
                    case 'BTINFMUDT':
                    case 'BTINFLU':
                        $scope.tempConnectionRequest.id_p_calendar = $scope.calendars[1].id
                        break
                    case 'BTINFCUST':
                    default:
                        $scope.tempConnectionRequest.id_p_calendar = $scope.calendars[0].id
                }
            }
            $scope.changeCalendar()
        }
    }

    $scope.changedVoltageDomain = () => {
        delete $scope.tempConnectionRequest.id_p_calendar
        delete $scope.tempConnectionRequest.routing_tariff
        delete $scope.tempConnectionRequest.max_power
        delete $scope.tempConnectionRequest.long_usage_context
        delete $scope.tempConnectionRequest.phasing
        $scope.tempConnectionRequest.temp_class_powers = {}
        $scope.refreshMaxStart()
    }

    $scope.refreshCategories = () => {
        $scope.refreshingCategories = true
        return DataAccess.getRefContractCategories({ id_account: $scope.id_account, energy_type: 'ELEC' }).$promise.then((categories) => {
            $scope.categories = categories
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingCategories = false
        })
    }

    $scope.minStart = moment().add(1, 'day').startOf('day').toDate()
    // Get the maximum delays to the start date
    DataAccessVariables.get({ variables: 'TEMPORARY_CONNEXION_DEFAULT_MAX_START_DELAY,TEMPORARY_CONNEXION_PARIS_MAX_START_DELAY,TEMPORARY_CONNEXION_HTA_MAX_START_DELAY' }).$promise
        .then((variables) => {
        $scope.defaultMaxStartDelay = variables['TEMPORARY_CONNEXION_DEFAULT_MAX_START_DELAY']
        $scope.parisMaxStartDelay = variables['TEMPORARY_CONNEXION_PARIS_MAX_START_DELAY']
        $scope.htaMaxStartDelay = variables['TEMPORARY_CONNEXION_HTA_MAX_START_DELAY']
    })
    $scope.maxStartDelay=$scope.defaultMaxStartDelay
    $scope.maxStart = moment().add($scope.maxStartDelay, 'day').startOf('day').toDate()

    $scope.refreshMaxStart = () => {
        if ($scope.tempConnectionRequest.voltage_domain === 'HTA') {
            $scope.maxStartDelay=$scope.htaMaxStartDelay
        } else if ($scope.tempConnectionRequest.addr_post_code.startsWith('75')){
            $scope.maxStartDelay=$scope.parisMaxStartDelay
        } else {
            $scope.maxStartDelay=$scope.defaultMaxStartDelay
        }
        $scope.maxStart = moment().add($scope.maxStartDelay, 'day').startOf('day').toDate()
    }

    $scope.changeStart = () => {
        $scope.tempConnectionRequest.end_date = null
        const sup = $scope.tempConnectionRequest.case_code === 'F800'
        $scope.endDateMessage = sup ? '29j à 1 an après pose' : 'dans les 28 jours après pose'
        if ($scope.tempConnectionRequest.start_date) {
            $scope.minEnd = moment($scope.tempConnectionRequest.start_date).startOf('day').add(sup ? 28 : 1, 'day').toDate()
            $scope.maxEnd = moment($scope.tempConnectionRequest.start_date).startOf('day').add(sup ? 365 : 27, 'day').toDate()
        }
        $scope.refreshVoltageDomains()
    }

    $scope.changeStart()

    $scope.createTicket = function () {
        $scope.creating = true
        const toOmit = ['start_date', 'end_date', 'otherMotivation']
        if (!$scope.isLU()) {
            toOmit.push('long_usage_context')
        }
        const payload = _.assign(_.omit($scope.tempConnectionRequest, toOmit), {
            start_date: moment($scope.tempConnectionRequest.start_date).format('YYYY-MM-DD'),
            end_date: moment($scope.tempConnectionRequest.end_date).format('YYYY-MM-DD'),
            motivation: $scope.isMotivationOther($scope.tempConnectionRequest.motivation) ? $scope.tempConnectionRequest.otherMotivation : $scope.tempConnectionRequest.motivation,
        })
        return ApiAdmin.postTemporaryConnectionRequest(payload).$promise.then(() => {
            AlertManager.success('Demande créée avec succès')
            $scope.ok()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.updateTempClassPower = (tempClass) => {
        const tcp = $scope.tempConnectionRequest.temp_class_powers
        /* eslint-disable no-fallthrough */
        switch (tempClass) {
            case 'PTE':
                tcp.HPH = tcp.HPH < tcp.PTE ? tcp.PTE : (tcp.HPH || tcp.PTE)
            case 'HPH':
                tcp.HCH = tcp.HCH < tcp.HPH ? tcp.HPH : (tcp.HCH || tcp.HPH)
            case 'HCH':
                tcp.HPE = tcp.HPE < tcp.HCH ? tcp.HCH : (tcp.HPE || tcp.HCH)
            case 'HPE':
                tcp.HCE = tcp.HCE < tcp.HPE ? tcp.HPE : (tcp.HCE || tcp.HPE)
            case 'HCE':
            default:
        }
    }

    $scope.checkTempClassPowers = () => {
        return !!$scope.tempConnectionRequest.temp_class_powers.HPH
            && !!$scope.tempConnectionRequest.temp_class_powers.HCH
            && !!$scope.tempConnectionRequest.temp_class_powers.HPE
            && !!$scope.tempConnectionRequest.temp_class_powers.HCE
            && $scope.tempConnectionRequest.temp_class_powers.HPH
                <= $scope.tempConnectionRequest.temp_class_powers.HCH
                <= $scope.tempConnectionRequest.temp_class_powers.HPE
                <= $scope.tempConnectionRequest.temp_class_powers.HCE
            && ($scope.tempConnectionRequest.voltage_domain === 'BTSUP'
                || ($scope.tempConnectionRequest.temp_class_powers.PTE && $scope.tempConnectionRequest.temp_class_powers.PTE <= $scope.tempConnectionRequest.temp_class_powers.HPH))
    }

    const checkVoltageDomainSpecifics = () => {
        return ($scope.tempConnectionRequest.voltage_domain === 'BTINF' &&
        !!$scope.tempConnectionRequest.id_p_calendar &&
        !!$scope.tempConnectionRequest.max_power &&
        !!$scope.tempConnectionRequest.phasing) || (['BTSUP', 'HTA'].includes($scope.tempConnectionRequest.voltage_domain) && $scope.checkTempClassPowers())
    }

    $scope.canCreate = () => {
        return !!$scope.tempConnectionRequest.addr_num_street &&
            !!$scope.tempConnectionRequest.addr_city_lbl &&
            $scope.postcodeValid() &&
            !!$scope.tempConnectionRequest.technical_civ &&
            !!$scope.tempConnectionRequest.technical_givenname &&
            !!$scope.tempConnectionRequest.technical_sn &&
            !!$scope.tempConnectionRequest.technical_phone &&
            !!$scope.tempConnectionRequest.technical_mail &&
            !!$scope.tempConnectionRequest.case_code &&
            !!$scope.tempConnectionRequest.id_category &&
            !!$scope.tempConnectionRequest.start_date &&
            !!$scope.tempConnectionRequest.end_date &&
            !!$scope.isMotivationOk() &&
            !!$scope.tempConnectionRequest.label &&
            !!$scope.tempConnectionRequest.routing_tariff &&
            (!$scope.isLU() || $scope.tempConnectionRequest.long_usage_context) &&
            checkVoltageDomainSpecifics() &&
            (!!$scope.tempConnectionRequest.requester_civ &&
                !!$scope.tempConnectionRequest.requester_givenname &&
                !!$scope.tempConnectionRequest.requester_sn &&
                !!$scope.tempConnectionRequest.requester_mail) &&
            (!$scope.tempConnectionRequest.asked_id_prm || $scope.isPrmValid($scope.tempConnectionRequest.asked_id_prm))
    }

    $scope.openNewCategoryModal = () => {
        ModalService.openModal({ type: 'editCategoryModal', size: 'xlg', backdrop: 'static' },
            { category: null, id_account: $scope.id_account },
            (result) => {
                $scope.refreshCategories().then(() => {
                    $scope.tempConnectionRequest.id_category = result
                    $scope.refreshVoltageDomains()
                })
            })
    }

    $scope.isNotMobilePhone = () => {
        return $scope.tempConnectionRequest.technical_phone && !$scope.tempConnectionRequest.technical_phone.match(mobileRegex)
    }

    $scope.lookupAddr = function (addr) {
        $scope.searchingAddr = true
        return ApiUser.lookupStrictAddr({ q: addr }).$promise
        .finally(() => {
            $scope.searchingAddr = false
        })
    }

    $scope.updateAddress = function (data) {
        $scope.tempConnectionRequest.addr_num_street = data.addr_num_street
        $scope.tempConnectionRequest.addr_city_lbl = data.addr_city_lbl && data.addr_city_lbl.toUpperCase()
        $scope.tempConnectionRequest.addr_post_code = data.addr_post_code
        $scope.refreshMaxStart()
    }

    $scope.fillTechnicalWithRequester = () => {
        $scope.tempConnectionRequest.technical_civ = $scope.tempConnectionRequest.requester_civ
        $scope.tempConnectionRequest.technical_givenname = $scope.tempConnectionRequest.requester_givenname
        $scope.tempConnectionRequest.technical_sn = $scope.tempConnectionRequest.requester_sn
        $scope.tempConnectionRequest.technical_mail = $scope.tempConnectionRequest.requester_mail
    }

    $scope.ok = () => $uibModalInstance.close()
    $scope.close = () => $uibModalInstance.dismiss()
})
